import styled from "styled-components";
import React, { useEffect, useState } from "react";
import {
  DialogContent,
  Dialog,
  Grid,
  Typography,
  DialogTitle,
  DialogActions,
} from "@mui/material";

import AudienceForm from "./AudienceForm";
import { useAxios } from "../../../../hooks";
import {
  audienceObject,
  objectFromResponse,
} from "../../../audience components/create audience components/audienceObjects";
import { CancelButton } from "../../../css components/Button";
import { colors } from "../../../css components/Style";

const Card = styled(Dialog)`
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
`;

export default function AudienceDetailsDialog({
  details,
  setDetails,
  formikProps,
  editState,
}) {
  const axios = useAxios();
  const [formData, setFormData] = useState(audienceObject);

  useEffect(() => {
    if (details.state) {
      axios({
        url: "/brand/getDetailsOfAudience/" + details.id,
      }).then((response) => {
        if (response.status) {
          setFormData(objectFromResponse(response.data));
        }
      });
    }
  }, [axios, details.id, details.state, details.open]);

  const handleClose = () => {
    setDetails({ id: "", state: false });
  };

  return (
    <Card
      open={details.state}
      onClose={handleClose}
      PaperProps={{
        sx: {
          minWidth: "700px!important",
        },
      }}
    >
      <DialogTitle style={{ borderBottom: "1px solid #cbcbcb" }}>
        <Typography variant="h4" color={colors.sprintexBlue}>
          Audience Details
        </Typography>
      </DialogTitle>

      <DialogContent style={{ paddingBottom: "0px" }}>
        <Grid container spacing={3} style={{ padding: "30px 10px" }}>
          <AudienceForm
            formikProps={formikProps}
            editState={editState}
            audienceData={formData}
            component={""}
          />
        </Grid>
      </DialogContent>

      <DialogActions>
        <Grid item xs />
        <Grid item>
          <CancelButton variant="outlined" onClick={handleClose}>
            Cancel
          </CancelButton>
        </Grid>
      </DialogActions>
    </Card>
  );
}
